/**
 * @fileoverview Edit route - redirects to main onboarding since project data is now in profiles table
 * @module routes/onboarding/edit
 */

import { createFileRoute, redirect } from '@tanstack/react-router';

/**
 * Edit route configuration.
 *
 * Since project data is now stored directly in the profiles table,
 * this edit route simply redirects to the main onboarding route.
 */
export const Route = createFileRoute('/onboarding/edit')({
  beforeLoad: () => {
    // Redirect to main onboarding since project data is now in profiles table
    throw redirect({ to: '/onboarding' });
  },
});